import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { tss } from 'tss-react/mui';
import { ReleaseProps } from '../PressRelease';

const PressReleaseCard = ({ release }: { release: ReleaseProps }) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.root}>
      <Typography
        variant="body2"
        sx={{ textTransform: 'uppercase', fontSize: '14px' }}
      >
        {release.date}
      </Typography>
      <Box className={classes.mainFlex}>
        <Stack
          sx={{
            gap: 2
          }}
        >
          <Typography
            variant="h3"
            sx={theme => ({ color: theme.palette.secondary.main })}
          >
            {release.title}
          </Typography>
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: release.description }}
          />
        </Stack>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'end',
            gap: 1,
            flexGrow: 0
          }}
        >
          <Button
            component={Link}
            to={release.file.link}
            target="_blank"
            variant="outlined"
            sx={{ display: 'flex', gap: 1 }}
          >
            Discover
          </Button>

          {release.file.size !== undefined && (
            <Typography variant="caption" sx={{ color: '#b7b7b7' }}>
              {release.file.size}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PressReleaseCard;
const useStyles = tss.create(({ theme }) => ({
  root: {
    backgroundColor: 'white',
    padding: '24px 48px',
    marginY: '16px'
  },
  mainFlex: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '32px',
    marginTop: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  }
}));
